
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { WebApiURL } from '../Constants/Constants';
const FileContext = createContext();

export const FileProvider = ({ children }) => {
  const [componentName, setComponentName] = useState('');
  const [section, setSection] = useState('');
  const [allDocuments, setAllDocuments] = useState([]);
  const [filteredDocuments, setFilteredDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [empComponentName, setEmpComponentName] = useState('');
  const [empSection, setEmpSection] = useState('');
  const [allEmployees, setAllEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [empLoading, setEmpLoading] = useState(false);
  useEffect(() => {
    fetchAllDocuments();
    fetchAllEmployees();
  }, []);

  useEffect(() => {
    filterDocuments();
  }, [componentName, section, allDocuments]);

  useEffect(() => {
    filterEmployees();
  }, [empComponentName, empSection, allEmployees]);

  const fetchAllDocuments = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${WebApiURL}File/all`);
      setAllDocuments(response.data || []);
    } catch (error) {
      console.error('Failed to fetch documents:', error);
      setAllDocuments([]);
    } finally {
      setLoading(false);
    }
  };

  const safeTrim = (value) => {
    return typeof value === 'string' ? value.trim().toLowerCase() : '';
  };

  const filterDocuments = () => {
    const filtered = allDocuments.filter((doc, index) => {
      const docComponent = safeTrim(doc?.component);
      const docSection = safeTrim(doc?.section);
      const matchesComponent = componentName
        ? docComponent === componentName.trim().toLowerCase()
        : true;
      const matchesSection = section
        ? docSection === section.trim().toLowerCase()
        : true;
      return matchesComponent && matchesSection;
    });
    setFilteredDocuments(filtered);
  };
  const fetchAllEmployees = async () => {
    try {
      setEmpLoading(true);
      const response = await axios.get(`${WebApiURL}File/AllEmployees`);
      setAllEmployees(response.data || []);
    } catch (err) {
      console.error('Error fetching employees:', err);
      setAllEmployees([]);
    } finally {
      setEmpLoading(false);
    }
  };

  const filterEmployees = () => {
    const filtered = allEmployees.filter((emp) => {
      const empComponent = safeTrim(emp?.component);
      const empSection = safeTrim(emp?.section);

      const matchesComponent = empComponentName
        ? empComponent === safeTrim(empComponentName)
        : true;
      const matchesSection = empSection
        ? empSection === safeTrim(empSection)
        : true;

      return matchesComponent && matchesSection;
    });

    setFilteredEmployees(filtered);
  };
  return (
    <FileContext.Provider
      value={{
        componentName,
        setComponentName,
        section,
        setSection,
        documents: filteredDocuments,
        loading,
        refetchDocuments: fetchAllDocuments,
        empComponentName,
        setEmpComponentName,
        empSection,
        setEmpSection,
        employees: filteredEmployees,
        empLoading,
        refetchEmployees: fetchAllEmployees,
        allDocuments
      }}
    >
      {children}
    </FileContext.Provider>
  );
};

export const useFileContext = () => useContext(FileContext);
